export default {
  getCents(price) {
    if (!price && price !== 0) return ''
    return parseFloat(price).toFixed(2)
  },
}